export const USER = 'user'
export const GROUP_ID = 'groupId'
export const MAX_TIME = 'maxTime'
export const TOKEN = 'tokenStr'
